export default __webpack_public_path__ + "static/media/ramp-right.4ad9b054.svg";